import React, { useEffect, useState } from 'react'
import { Alert } from 'react-bootstrap'
import { getAllUsers, updateUser, getUser, resetSLCGeneral } from '../../../../Firebase/Users-CRUD'

export default function UUIDTable() {

    const [members, setMembers] = useState([])
    const [loadingState, setLoadingState] = useState({show: false})
    const [statePayments, setStatePayments] = useState([])

    useEffect(() => {

        async function loadUsers() {

            const users = await getAllUsers()

            let temp = []

            users.map((user) => {
                temp.push(user)
            })
            setMembers(temp)

        }
        loadUsers()
    }, [])

    const handleAuthLevelChange = async (uuid) => {
        console.log(uuid)
        setLoadingState({show: true, variant: "warning", message: "Loading"})
        const newLevel = document.getElementById(`auth-level-${uuid}`).value
        await updateUser(uuid, { authLevel: newLevel })
        setLoadingState({show: true, variant: "success", message: `Changed Auth to ${newLevel}`})
        

    }


  return (
    <div>
      <h3 class="text-center">Grandview FBLA Unique User Identier</h3>
      { loadingState.show && <Alert variant={`${loadingState.variant}`} >{loadingState.message}</Alert>}
      <table class="table">
        <thead>
            <tr>
                <th class="" scope="col">Name</th>
                <th class="" scope="col">UUID</th>
            </tr>
        </thead>
        <tbody>
            {
                members.map((member, i) => {
                    if (member.General_Registration){
                        return <tr>
                            <td class="">{member.General_Registration.Name}</td>
                            <td class="">{member.UUID}</td>
                        </tr>
                    } else if (!member.General_Registration){
                        return <tr>
                            <td class="">{member.Email}</td>
                            <td class="">{member.UUID}</td>
                        </tr>
                    }
                })
            }
            
            
        </tbody>
      </table>
    </div>

  )
}
